import useUserPreference from "../user-preferences/useUserPreference"
import type { TipId, TipStatus } from "./types"
import { useLegacyTipStatus } from "./useLegacyTipStatus"

export function useTipStatus(id?: TipId) {
  const preference = useUserPreference<TipStatus>({
    key: "tip:status",
    scope: id,
    enabled: !!id
  })
  const { status, loading } = useLegacyTipStatus(id, preference)
  return [status, preference.setStatus, loading] as const
}

export default useTipStatus
